import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';

@Component({
  selector: 'app-customer-profile-contact-detail',
  templateUrl: './customer-profile-contact-detail.component.html',
})
export class CustomerProfileContactDetailComponent
  implements OnInit, OnDestroy
{
  contactDetails = true;
  customerContactForm!: FormGroup;
  customerDataObsSubscription!: Subscription;
  customerDataEventObsSubscription!: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.customerDataObsSubscription = this.customerService
      .getCustomerDataObservable()
      .subscribe((res) => {
        console.log(res);
        this.patchCustomerContactData(res);
      });
    this.customerDataEventObsSubscription = this.customerService
      .getCustomerFormDataEventObsevable()
      .subscribe((res) => {
        console.log(res);
        this.customerService.sendCustomerFormData({
          ...this.customerContactForm.value,
        });
      });
  }

  initForm() {
    this.customerContactForm = this.formBuilder.group({
      Mobile: [
        '',
        [Validators.maxLength(10), Validators.pattern(/^[6-9]\d{9}$/)],
      ],
      Address: ['', Validators.required],
      TelephoneNo: ['', Validators.required],
      state: ['', Validators.required],
      postalCode: ['', Validators.required, Validators.pattern('[0-9]{6}')],
      city: ['', Validators.required],
      country: ['', Validators.required],
    });
  }

  patchCustomerContactData(data: any) {
    this.customerContactForm.patchValue({
      Mobile: data.Mobile,
      Address: data.Address,
      TelephoneNo: data.TelephoneNo,
      state: data.state,
      postalCode: data.postalCode,
      city: data.city,
      country: data.country,
    });
  }

  ngOnDestroy(): void {
    this.customerDataObsSubscription?.unsubscribe();
    this.customerDataEventObsSubscription?.unsubscribe();
  }
  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
